import { useState } from 'react';
import { InputSearch } from 'sonata-react-components';

import { useListDownload } from '../../../export/useListDownload';
import { useMultiFlightMap } from '../../../MultiFlightMap.context';
import Filters from '../Filters/Filters';
import ListActionButtons from '../ListActionButtons/ListActionButtons';
import { ListDownloadMenu } from '../ListDownloadMenu/ListDownloadMenu';

import type { SelectorOptionPropsInterface } from 'sonata-react-components';
import type { FilterPanelConfig } from '../Filters/filters.types';

type FilterConfig = {
  label?: string;
  onChange: (options: SelectorOptionPropsInterface | SelectorOptionPropsInterface[]) => void;
  options: SelectorOptionPropsInterface[];
  value: SelectorOptionPropsInterface[];
};

type SearchConfig = {
  id: string;
  name: string;
  onChange: (text: string) => void;
  placeholder: string;
};

type Props = {
  actionButtonsId: string;
  /** Flat mode: number of applied filters. */
  activeFiltersCount?: number;
  filters?: FilterConfig[];
  filtersId: string;
  /** Flat mode: clears every filter. */
  onClearFilters?: () => void;
  /** Location and attributes sections; takes over `filters`. */
  panel?: FilterPanelConfig;
  search: SearchConfig;
};

function ListsHeader({
  actionButtonsId,
  activeFiltersCount,
  filters,
  filtersId,
  onClearFilters,
  panel,
  search
}: Readonly<Props>) {
  const { list } = useMultiFlightMap();
  const [isDownloadMenuOpen, setIsDownloadMenuOpen] = useState(false);
  // File sizes are only estimated while the menu is open
  const { counts, download, isDownloading, sizes } = useListDownload(list, { estimateSizes: isDownloadMenuOpen });

  return (
    <div className="mapList__header">
      <InputSearch
        className="mapList__headerSearch"
        id={search.id}
        lens
        name={search.name}
        onChange={search.onChange}
        placeholder={search.placeholder}
        tiny
      />
      <ListDownloadMenu
        counts={counts}
        disabled={counts.all === 0 || isDownloading}
        id={`${actionButtonsId}-download`}
        onOpenChange={setIsDownloadMenuOpen}
        onSelect={download}
        sizes={sizes}
      />
      <Filters
        activeCount={activeFiltersCount}
        filters={filters}
        id={filtersId}
        onClear={onClearFilters}
        panel={panel}
      />
      <ListActionButtons id={actionButtonsId} />
    </div>
  );
}

export default ListsHeader;
